// „Guthaben aufgebraucht"-Karte für 402-Antworten (credits_exhausted).
// Shop-Link kommt aus der 402-Payload (Fallback: /config/public), dazu der
// Hinweis auf /activate zum Einlösen eines neuen Codes.

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { isQuotaDetail } from "@/api/client";
import { usePublicConfig } from "@/lib/publicConfig";

export default function QuotaExhaustedCard({
  detail,
  onDismiss,
}: {
  detail?: unknown;
  onDismiss?: () => void;
}) {
  const { t } = useTranslation();
  const cfg = usePublicConfig();
  const quota = isQuotaDetail(detail) ? detail : null;
  const shopUrl = quota?.shop_url ?? cfg?.shop_url ?? null;

  return (
    <div className="rounded-xl border border-ca-surface-border bg-ca-card p-5 space-y-3">
      <div className="flex items-start justify-between gap-4">
        <p className="text-sm font-black uppercase tracking-widest text-ca-surface-ink">
          {t("credits.exhaustedTitle")}
        </p>
        {onDismiss && (
          <button
            onClick={onDismiss}
            className="text-ca-surface-muted hover:text-ca-surface-ink text-xs font-bold uppercase tracking-widest transition"
          >
            {t("common.close")}
          </button>
        )}
      </div>
      <p className="text-sm text-ca-surface-muted leading-relaxed">
        {quota
          ? t("credits.exhaustedBody", { cost: quota.cost, balance: quota.balance })
          : t("credits.exhaustedGeneric")}
      </p>
      <div className="flex flex-wrap gap-3 pt-1">
        {shopUrl && (
          <a
            href={shopUrl}
            target="_blank"
            rel="noreferrer"
            className="px-4 py-2 rounded-md bg-ca-accent text-ca-brand text-xs font-black uppercase tracking-widest hover:bg-brand-gold-dark transition"
          >
            {t("credits.buy")}
          </a>
        )}
        <Link
          to="/activate"
          className="px-4 py-2 rounded-md border border-ca-surface-border text-ca-surface-accent text-xs font-black uppercase tracking-widest hover:border-ca-accent transition"
        >
          {t("credits.redeem")}
        </Link>
      </div>
    </div>
  );
}
